export default __webpack_public_path__ + "static/1396-afe6f1f879f984377c063087de2c6541.gif";